import def from "ajv/dist/vocabularies/applicator/additionalItems";
import { jwtDecode } from "jwt-decode";

class TenantManager {
  static defaultTenant = "elagi";
  // Set tenant in local storage
  static setTenant(tenant) {
    localStorage.setItem("tenant", tenant);
  }

  // Get tenant from local storage
  static getTenant(token) {
    //console.log({ token });

    if (!token) return "NO_TENANT";

    const decoded = jwtDecode(token);

    if (decoded?.tenant !== "superadmin") return decoded?.tenant;
    const fetchedTenant = localStorage.getItem("tenant");
    if (fetchedTenant) {
      return fetchedTenant;
    } else {
      localStorage.setItem("tenant", this.defaultTenant);
      return this.defaultTenant;
    }
  }
}

export default TenantManager;
